import PropTypes from 'prop-types';
import React from 'react';
import {
  FieldContainer,
  Label,
  Required,
  StyledInput,
  HelperText,
} from './StyledComponents';

/**
 * Input - A reusable form input component
 *
 * @param {string} label - Label text for the input
 * @param {boolean} required - Whether the field is required (shows red asterisk)
 * @param {string} value - The input value
 * @param {Function} onChange - Callback when value changes
 * @param {string} placeholder - Placeholder text
 * @param {string} type - Input type (text, email, tel, number, etc.)
 * @param {string} helperText - Helper/error text below the input
 * @param {boolean} error - Whether the input has an error state
 * @param {string} width - Width of the input (default: "100%")
 * @param {string} maxWidth - Max width of the input
 */
const Input = ({
  label,
  required = false,
  value,
  onChange,
  placeholder,
  type = 'text',
  helperText,
  error = false,
  width = '100%',
  maxWidth,
  ...props
}) => {
  return (
    <FieldContainer width={width} maxWidth={maxWidth}>
      {label && (
        <Label>
          {label} {required && <Required>*</Required>}
        </Label>
      )}
      <StyledInput
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        error={error}
        onWheel={(e) => {
          if (type === 'number') e.target.blur();
        }}
        {...props}
      />
      {helperText && <HelperText error={error}>{helperText}</HelperText>}
    </FieldContainer>
  );
};

Input.propTypes = {
  label: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  helperText: PropTypes.string,
  error: PropTypes.bool,
  width: PropTypes.string,
  maxWidth: PropTypes.string,
};

export default Input;
